import { apiRoutes } from 'routes';
import FetchHelpers from 'utils/FetchHelpers';

export default {
  current(documentId) {
    const path = apiRoutes.currentMappingMultiSheetPath(documentId);
    return FetchHelpers.get(path);
  },
  create(params) {
    const path = apiRoutes.mappingsMultiSheetPath();
    return FetchHelpers.post(path, params);
  },
  result(documentId) {
    const path = apiRoutes.mappingMultiSheetResult(documentId);
    return FetchHelpers.post(path);
  },
  validate(params) {
    const path = apiRoutes.mappingsMultiSheetValidatePath();
    return FetchHelpers.post(path, params);
  },
};
